import { axiosFetch } from "../../utils/AxiosFetch";
import { StructureConstants } from "../constants/structure.constants";
import { SnackbarActions } from "./snackbar.actions";

export const fetchChartData = (req) => (dispatch) => {

  axiosFetch({
    method: "GET",
    url: `/employees/structure/${req}`,
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch(fetchChartData_Succeed(res));
      }
      if (res.status === 400) {
        dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
      }
      if (res.status === 401) {
        window.location.href = '/';
      }
    })
    .catch((err) => {
      dispatch(fetchChartData_Failed(err))
    });

  function fetchChartData_Succeed(data) {

    return {

      type: StructureConstants.GET_STRUCTURE_SUCCESS,
      payload: data

    }
  }

  function fetchChartData_Failed(err) {

    return {

      type: StructureConstants.GET_STRUCTURE_FAILED,
      payload: err

    }
  }
};


export const fetchChartData2 = (id) => (dispatch) => {

  axiosFetch({
    method: "GET",
    url: `/employees/structure/demo/${id}`,
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch(ChartData_Succeed(res));
      }
      if (res.status === 400) {
        dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
      }
      if (res.status === 401) {
        window.location.href = '/';
      }
    })
    .catch((err) => {
      dispatch(ChartData_Failed(err))
    });

  function ChartData_Succeed(data) {

    return {

      type: StructureConstants.GET_ORG_CHART_SUCCESS,
      payload: data

    }
  }

  function ChartData_Failed(err) {

    return {

      type: StructureConstants.GET_ORG_CHART_FAILURE,
      payload: err

    }
  }
};